import React, { useEffect, useState } from 'react';

// Rotating shimmer word for the hero title. Cross-fades + shimmers through a
// list of words; respects prefers-reduced-motion (renders the first word static).
export default function RotatingWord({ words = [], interval = 2200, className = '' }) {
  const [i, setI] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (!words.length) return undefined;
    const reduce =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return undefined;
    const id = setInterval(() => {
      setShow(false);
      setTimeout(() => {
        setI((p) => (p + 1) % words.length);
        setShow(true);
      }, 350);
    }, interval);
    return () => clearInterval(id);
  }, [words, interval]);

  if (!words.length) return null;
  return (
    <span
      className={`bp-shimmer-word ${show ? 'bp-word-in' : 'bp-word-out'} ${className}`}
      data-testid="hero-rotating-word"
    >
      {words[i]}
    </span>
  );
}
